import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../shared/theme.service';

@Component({
  selector: 'vb-lxp-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vb-lxp-footer.component.html',
  styleUrls: ['./vb-lxp-footer.component.css'],
})
export class VbLxpFooterComponent {
  @Input() imagePaths: { src: string; link: string }[] = [];

  public themeService = inject(ThemeService);
}
